import { useClientStore } from "@/store/client";
import { computed } from "vue";

export default () => {
  const client = useClientStore();

  const privacyMode = computed(() => (client.me ? client.me.jwt.paranoid !== "off" : true));
  const enhancedPrivacyMode = computed(() => (client.me ? client.me.jwt.paranoid === "strict" : false));

  return {
    privacyMode,
    enhancedPrivacyMode,
  };
};
